import { render } from "./baseAccount.vue?vue&type=template&id=2bb9852e"
import script from "./baseAccount.vue?vue&type=script&lang=js"
export * from "./baseAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__